import { G2BadgeTop50, MetaBadge } from '@mm/icons';
import iconiqLogo from 'assets/iconiq-logo.png';
import classNames from 'classnames';
import React from 'react';
import { Logo } from '../../../layout/BotBuilderSidebar/Logo/Logo';
import { useWebsiteReportModals } from '../XRayOnboarding/WebsiteReportSummary/use-website-report-modals';
import automationScheme from './images/automations-scheme.png';
import buildingSrc from './images/building.png';
import correlationSrc from './images/correlation.png';
import shoppingSrc from './images/shopping-bag.png';
import richDad from './images/rich-dad.png';
import agileOffroad from './images/agile-offroad.png';
import tra from './images/tra.png';
import realEstate from './images/real-estate.png';
import analyticsSrc from './images/analytics.png';
import howItWorksSrc from './images/how-it-works.png';
import integrationsSrc from './images/integrations.png';
import xRaySrc from './images/x-ray.png';
import styles from './WelcomeNonSQL.module.css';
import { Button } from '@mm/components';

export const WelcomeNonSQL = () => {
  const { openSignupModal, websiteURL = 'yourwebsite.com ' } =
    useWebsiteReportModals();

  return (
    <div className={classNames(styles.container, styles.column)}>
      <div
        className={styles.block}
        style={{ paddingTop: 0, paddingLeft: '40px' }}
      >
        <div className={classNames(styles.row, styles.topHeader)}>
          <Logo className={styles.mainLogo} />
          <div className={classNames(styles.row, styles.logos)}>
            <img src={iconiqLogo} className={styles.iconiq} />
            <G2BadgeTop50 className={styles.top50Logo} />
            <MetaBadge className={styles.meta} />
          </div>
        </div>

        <div className={classNames(styles.row, styles.mainScreen)}>
          <div className={classNames(styles.column, styles.mainTitle)}>
            <div className={styles.text}>
              Get the emails of your anonymous visitors
            </div>

            <div className={classNames(styles.column, styles.urlBlock)}>
              {websiteURL && (
                <div className={classNames(styles.text, styles.url)}>
                  {websiteURL}
                </div>
              )}
              <div className={styles.text}>
                is perfect for self service Customers.ai{' '}
              </div>
            </div>
            <Button
              onClick={openSignupModal}
              css={{ container: styles.primaryButton }}
            >
              Gather Emails in 90 seconds
            </Button>
          </div>
          <img src={automationScheme} className={styles.mainImage} />
        </div>
      </div>

      <div className={styles.layer}>
        <div className={styles.block}>
          <div className={classNames(styles.column, styles.screenNumbers)}>
            <div className={styles.sectionTitle}>The numbers don’t lie</div>
            <div className={classNames(styles.row, styles.statItems)}>
              <div className={classNames(styles.column, styles.statItem)}>
                <img src={buildingSrc} className={styles.icon} />
                <div className={classNames(styles.column, styles.gap4)}>
                  <span
                    className={classNames(
                      styles.secondaryText,
                      styles.mainTitle,
                    )}
                  >
                    100%
                  </span>
                  <span
                    className={classNames(
                      styles.secondaryText,
                      styles.secondaryTitle,
                    )}
                  >
                    Legally Compliant
                  </span>
                </div>
                <div className={styles.secondaryText}>
                  We follow all the laws and regulations to always comply{' '}
                </div>
              </div>

              <div className={classNames(styles.column, styles.statItem)}>
                <img src={correlationSrc} className={styles.icon} />
                <div className={classNames(styles.column, styles.gap4)}>
                  <span
                    className={classNames(
                      styles.secondaryText,
                      styles.mainTitle,
                    )}
                  >
                    1.2B
                  </span>
                  <span
                    className={classNames(
                      styles.secondaryText,
                      styles.secondaryTitle,
                    )}
                  >
                    Events Daily
                  </span>
                </div>
                <div className={styles.secondaryText}>
                  In our network, we see the traffic for 100k+ US-based sites{' '}
                </div>
              </div>

              <div className={classNames(styles.column, styles.statItem)}>
                <img src={shoppingSrc} className={styles.icon} />
                <div className={classNames(styles.column, styles.gap4)}>
                  <span
                    className={classNames(
                      styles.secondaryText,
                      styles.mainTitle,
                    )}
                  >
                    176M
                  </span>
                  <span
                    className={classNames(
                      styles.secondaryText,
                      styles.secondaryTitle,
                    )}
                  >
                    US Shoppers in Network
                  </span>
                </div>
                <div className={styles.secondaryText}>
                  We have a 73% USA shoppers match rate{' '}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.block}>
        <div
          className={classNames(styles.sectionTitle, styles.caseStudiesTitle)}
        >
          See how businesses like yours are growing with Customers.ai
        </div>
        <div className={styles.caseStudies}>
          <div className={classNames(styles.column, styles.caseStudy)}>
            <img src={richDad} />
            <div className={styles.secondaryText}>
              The Rich Dad Company more than doubled their email open rate.
              <span className={styles.tag}>x 2</span>
            </div>
          </div>
          <div className={classNames(styles.column, styles.caseStudy)}>
            <img src={realEstate} />
            <div className={styles.secondaryText}>
              Commercial Real Estate company generated $67K in LTV revenue.
              <span className={styles.tag}>+ $67K</span>
            </div>
          </div>
          <div className={classNames(styles.column, styles.caseStudy)}>
            <img src={agileOffroad} />
            <div className={styles.secondaryText}>
              Agile Off Road Driving 5.5x more email revenue with Pixel.
              <span className={styles.tag}>x 5.5</span>
            </div>
          </div>
          <div className={classNames(styles.column, styles.caseStudy)}>
            <img src={tra} />
            <div className={styles.secondaryText}>
              Travel Resorts of America Booking $1M+ reservations with our X-Ray
              Pixel & auto-outreach tools.
              <span className={styles.tag}>+ $1M</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.layer}>
        <div className={styles.block}>
          <div className={classNames(styles.column, styles.freeTrialScreen)}>
            <div className={classNames(styles.column, styles.gap4)}>
              <div className={styles.sectionTitle}>
                Start Your Free Trial of Customers.ai!
              </div>
              <div className={styles.secondaryText}>
                Based on your input, the best solution for your business is to
                start your free trial of Customers.ai today. We'll show you how
                to generate your first 50 website leads and send automated
                emails for free — no credit card required.
              </div>
            </div>
            <Button
              css={{ container: styles.primaryButton }}
              onClick={openSignupModal}
            >
              Start Free Trial
            </Button>
          </div>
        </div>
      </div>

      <div className={classNames(styles.block, styles.reducedBlock)}>
        <div className={styles.sectionTitle}>Why Customers.ai?</div>

        <div
          className={classNames(styles.row, styles.advatangeBlock)}
          style={{ marginTop: '48px' }}
        >
          <img src={howItWorksSrc} className={styles.advatangeImage} />
          <div className={classNames(styles.column, styles.description)}>
            <div className={classNames(styles.column, styles.gap4)}>
              <div className={styles.secondaryTitle}>
                Reach your hidden buyers
              </div>
              <div className={styles.secondaryText}>
                Email visitors even if they don’t fill out your form
              </div>
            </div>
            <Button
              color="secondary-blue"
              css={{ container: styles.secondaryButton }}
              onClick={openSignupModal}
            >
              Start Free Trial
            </Button>
          </div>
        </div>
      </div>

      <div className={styles.layer}>
        <div className={classNames(styles.block, styles.reducedBlock)}>
          <div className={classNames(styles.row, styles.advatangeBlock)}>
            <div className={classNames(styles.column, styles.description)}>
              <div className={classNames(styles.column, styles.gap4)}>
                <div className={styles.secondaryTitle}>
                  Maximize your conversions
                </div>
                <div className={styles.secondaryText}>
                  Retargeting by email is 10x more effective than retargeting
                  with ads
                </div>
              </div>
              <Button
                color="secondary-blue"
                css={{ container: styles.secondaryButton }}
                onClick={openSignupModal}
              >
                Start Free Trial
              </Button>
            </div>
            <img src={analyticsSrc} className={styles.advatangeImage} />
          </div>
        </div>
      </div>

      <div className={classNames(styles.block, styles.reducedBlock)}>
        <div className={classNames(styles.row, styles.advatangeBlock)}>
          <div className={classNames(styles.column, styles.description)}>
            <div className={classNames(styles.column, styles.gap4)}>
              <div className={styles.secondaryTitle}>
                Integrate to your existing CRM
              </div>
              <div className={styles.secondaryText}>
                Customers.ai connects to your website and your CRM/ESP to boost
                your existing conversion funnel
              </div>
            </div>
            <Button
              color="secondary-blue"
              css={{ container: styles.secondaryButton }}
              onClick={openSignupModal}
            >
              Start Free Trial
            </Button>
          </div>
          <img src={integrationsSrc} className={styles.advatangeImage} />
        </div>
      </div>

      <div className={styles.layer}>
        <div className={classNames(styles.block, styles.reducedBlock)}>
          <div className={classNames(styles.row, styles.advatangeBlock)}>
            <img src={xRaySrc} className={styles.advatangeImage} />
            <div className={classNames(styles.column, styles.description)}>
              <div className={classNames(styles.column, styles.gap4)}>
                <div className={styles.secondaryTitle}>
                  Multiply your email list growth
                </div>
                <div className={styles.secondaryText}>
                  Automatically capture 7x more emails and grow your list 7x
                  faster
                </div>
              </div>
              <Button
                color="secondary-blue"
                css={{ container: styles.secondaryButton }}
                onClick={openSignupModal}
              >
                Start Free Trial
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className={classNames(styles.column, styles.footer)}>
        <div className={styles.italic}>Find your customers with</div>
        <Logo className={styles.logoOutlined} />
      </div>
    </div>
  );
};
